import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMBadgeView extends React.Component {
  render(){
    const label = SMFormatHelper.unreadNumberLabel(this.props.badgeNumber);
    let element = null;
    if (label) {
      return <span className="site-header__nav-bagde">{label}</span>;
    }
    else if (this.props.badgeNumber == 0 && (this.props.hasTodo || this.props.hasAnnouncements)) {
      return <span className="site-header__nav-bagde"><i className="fa fa-exclamation"></i></span>;
    }
    return null;
  }
}
export default SMBadgeView;



// WEBPACK FOOTER //
// ./app/javascript/components/shared/SMBadgeView.jsx